import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

// Attaches Tribute.js to a plain <input> so typing "@" suggests employees
// from /mentions/employees.json. Selecting an item inserts "@First Last "
// as plain text into the input — the server then parses & strips the token
// via Subtasks::MentionParser to set assigned_employee_id.
export default class extends Controller {
  static values = { taskId: Number }

  connect() {
    this.tribute = new Tribute({
      collection: [
        {
          trigger: "@",
          lookup: "display_name",
          allowSpaces: true,
          menuItemLimit: 5,
          values: this.fetchEmployees.bind(this),
          selectTemplate: (item) => `@${item.original.display_name} `,
          menuItemTemplate: (item) => item.original.display_name,
        },
      ],
    })
    this.tribute.attach(this.element)
  }

  disconnect() {
    this.tribute?.detach(this.element)
  }

  fetchEmployees(text, callback) {
    const params = new URLSearchParams({ query: text || "" })
    if (this.hasTaskIdValue) params.set("task_id", this.taskIdValue)

    fetch(`/mentions/employees.json?${params.toString()}`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((employees) => callback(employees))
      .catch(() => callback([]))
  }
}
